import { Card, CardContent } from "@/components/ui/card";

export const QuickActionCard = ({ icon: Icon, iconBgColor, iconColor, title, subtitle, borderColor, onClick }) => (
  <Card 
    className={`bg-white shadow-sm hover:shadow-md transition-shadow cursor-pointer border-l-4 ${borderColor}`}
    onClick={onClick}
    data-testid={`quick-action-${title.toLowerCase().replace(/\s+/g, '-')}`}
  >
    <CardContent className="p-4 flex items-center gap-3">
      <div className={`p-2 ${iconBgColor} rounded-full`}>
        <Icon className={`w-5 h-5 ${iconColor}`} />
      </div>
      <div>
        <p className="font-medium text-slate-800">{title}</p>
        <p className="text-xs text-slate-500">{subtitle}</p>
      </div>
    </CardContent>
  </Card>
);

export default QuickActionCard;
